<template>
  <div class="Embedded">
    <navbar :showShadow="false" :scrollChange="false" :tabId="7"></navbar>
    <component :is="current"></component>
  </div>
</template>
<script>
export default {
  name: "Embedded",
  data() {
    return {
      current: "",
      componentMap: {
        1: "cargo-track", // 海运跟踪
        2: "air-track", // 空运跟踪
        3: "container-size-list", // 集装箱尺寸
        4: "freezer-box", // 冷藏
        5: "global-airport", // 机场查询
        6: "global-port", // 港口查询
        7: "global-country", // 国家查询
        8: "clearance-type",//通关状态查询
      },
    };
  },
  components: {
    CargoTrack: () => import("./components/cargo-track"),
    AirTrack: () => import("./components/air-track"),
    ContainerSizeList: () => import("./components/container-size-list"),
    FreezerBox: () => import("./components/freezer-box"),
    GlobalAirport: () => import("./components/global-airport"),
    GlobalPort: () => import("./components/global-port"),
    GlobalCountry: () => import("./components/GlobalCountry"),
    clearanceType: () => import("./components/clearance-type"),
  },
  watch: {},
  computed: {},
  created() {
    this.current = this.componentMap[this.$route.query.id || ""];
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/styles/variable.scss";
.Embedded {
  // padding-top: $navbarHeight + $EmbeddedHeight;
  min-height: 100vh;
}
</style>